import { SessionView } from "admin/src/server/mappers/session/session";
import { registerEmailSpeakerStringExpression } from "admin/src/ui/components/surveyJS/custom-expression-hooks/registerEmailSpeakerStringExpression";
import { registerProfileViewNameExpression } from "admin/src/ui/components/surveyJS/custom-expression-hooks/registerProfileViewNameExpression";
import { registerSpeakerPermissionsExpression } from "admin/src/ui/components/surveyJS/custom-expression-hooks/registerSpeakerPermissionsExpression";
import { registerTagIncludesExpression } from "admin/src/ui/components/surveyJS/custom-expression-hooks/registerTagIncludesExpression";
export type SurveyPreviewExpressionTypes = {
  registerEmailSpeakerStringExpression: () => void;
  registerProfileViewNameExpression: () => void;
  registerSpeakerPermissionsExpression: () => void;
  registerTagIncludesExpression: (
    session: SessionView,
    tags?: string[],
  ) => void;
  //   registerGeocodeExpression: () => void;
};

export const surveyPreviewExpressions: SurveyPreviewExpressionTypes = {
  registerEmailSpeakerStringExpression: registerEmailSpeakerStringExpression,
  registerProfileViewNameExpression: registerProfileViewNameExpression,
  registerSpeakerPermissionsExpression: registerSpeakerPermissionsExpression,
  registerTagIncludesExpression: registerTagIncludesExpression,
  //   registerGeocodeExpression: registerGeocodeExpression,
};
